import React, { lazy } from 'react';
import Loadable from 'components/loading/Loadable';
import { CertBoardApi } from 'api/community/CertBoardApi';
import { CertProvider } from './context';

const List = Loadable(lazy(() => import('./list')));
const Create = Loadable(lazy(() => import('./create')));
const Edit = Loadable(lazy(() => import('./edit')));

const CertBoardConfig = {
    routes: [
        {
            path: 'cert',
            children: [
                {
                    path: '',
                    element: <CertProvider><List /></CertProvider>
                },
                {
                    path: 'create',
                    element: <CertProvider><Create /></CertProvider>
                },
                {
                    path: 'modify/:code',
                    element: <CertProvider><Edit /></CertProvider>
                }
            ]
        }
    ],
    API: CertBoardApi
};

export default CertBoardConfig;
